import { useEffect, useState } from 'react';
import firebase from 'firebase';
import { useAtom } from 'jotai';
import { useCollectionData } from 'react-firebase-hooks/firestore';
// constants
import { firestoreKeys, supportTicketStatuses } from '../../../../../shared/utils/constants';
// hooks
import { useToast } from '../../../../../shared/hooks';
// state
import { userRecordAtom } from '../../../../../shared/state/atoms';
// services
import { useSupportTicketService, useMailService } from '../../../../../shared/services';

// --------------------------------------------------

export default function useHorizontalNavBar() {
  const [currentUser] = useAtom(userRecordAtom);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const conversationsCollectionRef = firebase.firestore().collection(firestoreKeys.CONVERSATIONS);
  const { showSuccess, showError } = useToast();
  const { createSupportTicket } = useSupportTicketService();
  const { sendSupportRequestEmail } = useMailService();

  const [conversations] = useCollectionData(
    currentUser ? conversationsCollectionRef.where('userIds', 'array-contains', currentUser.id) : null,
    {
      idField: 'id',
    }
  );

  useEffect(() => {
    if (!currentUser || !conversations) {
      return;
    }

    const hasUnread = conversations.some(
      (conversation) =>
        conversation.lastMessage?.isRead === false && conversation.lastMessage?.userId !== currentUser.id
    );
    setHasUnreadMessages(hasUnread);
  }, [currentUser, conversations]);

  const handleHelpRequest = async (formData) => {
    try {
      const userName = `${currentUser.details.firstName} ${currentUser.details.lastName}`;
      const userEmail = currentUser.contact?.emailAddress || '';

      const data = {
        details: {
          issueType: formData.subject,
          description: formData.description,
        },
        user: {
          userId: currentUser.id,
          userName,
          userType: 'Not Defined',
        },
        status: supportTicketStatuses.ACTIVE,
      };
      await createSupportTicket(data);

      // Send email notification to support@stintz.com
      await sendSupportRequestEmail({
        userName,
        userEmail,
        userId: currentUser.id,
        subject: formData.subject,
        description: formData.description,
      });

      showSuccess('Your request has been sent');
    } catch (error) {
      console.error('Error creating support ticket:', error);
      showError('Failed to send request, please try again');
      throw error;
    }
  };

  return { hasUnreadMessages, handleHelpRequest };
}
